module.exports = __webpack_public_path__ + "media/file_icons/powerpoint-9f211f56.png";